import {z} from '@hono/zod-openapi';

export const DeadStockBucketSchema = z
  .enum(['days0to89', 'days90to179', 'days180to364', 'days365plus', 'neverIssued'])
  .openapi('DeadStockBucket');

export type DeadStockBucket = z.infer<typeof DeadStockBucketSchema>;
